/* eslint-disable function-paren-newline */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-shadow */
/* eslint-disable prefer-const */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import { connect } from 'react-redux';

import Button from 'components/form/Button.component';
import { DOWNLOAD_EXCEL } from 'constants/csv.const';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';
import asArray from 'utils/arrays/asArray.util';
import { exportCSV } from 'utils/converters/csv.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import currencySign from 'utils/intl/currencySign.util';
import C from 'utils/values/constant.util';

import { convertToMoneyAfterVat } from 'reports/utils';

import CN from './DiscountByStylist.module.scss';

const TABLES_HEADERS = C({
  staff: 'Staff',
  category: 'Category',
  itemsCheckedOut: 'No. of items checked out',
  itemsDiscounted: 'Items discounted',
  percentItemsDiscounted: '% of items discounted',
  givenDiscount: 'Discounts given',
  percentGivenDiscount: '% Discounts given',
  serviceDiscount: 'Service Discounts',
  percentServiceDiscount: 'Service Discount %',
  retailDiscount: 'Retail Discounts',
  percentRetailDiscount: 'Retail Discount %',
});

class DiscountByStylist extends React.Component {
  makeDiscountTable = (data, discountReport) => {
    const discountTable = [];
    const salonTotalDiscount =
      discountReport.lastRequestResponse.service_total_discount +
      discountReport.lastRequestResponse.product_total_discount;

    let salonItemsChecked = 0;
    // const salonTotalDiscountNumber = discountReport.lastRequestResponse.discounts_given;
    let salonTotalDiscountNumber = 0;
    const { stylist_group } = discountReport.lastRequestResponse;
    let stlylistDiscount;
    let salonServiceDiscountTotal = 0;
    let salonProductDiscountTotal = 0;
    data.map((st) => {
      [stlylistDiscount] = Object.values(stylist_group).filter((s) => s.name === st.name);
      if (stlylistDiscount) {
        salonServiceDiscountTotal += stlylistDiscount.service_discount_total;
        salonProductDiscountTotal += stlylistDiscount.product_discount_total;
      }
    });

    data.map((st) => {
      let stlylistDiscount = Object.values(stylist_group).filter((s) => s.name === st.name)[0];

      const l = discountTable.length;
      let stylistTotalDiscountPercent = 0;
      let clientDiscountPercent = 0;
      let serviceDiscountPercent = 0;
      let retailDiscountPercent = 0;
      let totalClients = 0;
      let clientDiscountCount = 0;
      let service_discount_total = 0;
      let product_discount_total = 0;

      if (stlylistDiscount) {
        service_discount_total = stlylistDiscount.service_discount_total || 0;
        product_discount_total = stlylistDiscount.product_discount_total || 0;

        stylistTotalDiscountPercent =
          salonTotalDiscount !== 0 ? (service_discount_total + product_discount_total) / salonTotalDiscount : 0;
        clientDiscountPercent =
          stlylistDiscount.total_clients !== 0
            ? stlylistDiscount.client_discount_count / stlylistDiscount.total_clients
            : 0;
        serviceDiscountPercent =
          salonServiceDiscountTotal !== 0 ? service_discount_total / salonServiceDiscountTotal : 0;
        retailDiscountPercent =
          salonProductDiscountTotal !== 0 ? product_discount_total / salonProductDiscountTotal : 0;

        totalClients = stlylistDiscount.total_clients;
        salonItemsChecked += totalClients;
        clientDiscountCount = stlylistDiscount.client_discount_count;
        salonTotalDiscountNumber += clientDiscountCount;
      }

      discountTable[l] = {
        [TABLES_HEADERS.staff]: st.name,
        [TABLES_HEADERS.itemsCheckedOut]: totalClients.toString(),
        [TABLES_HEADERS.itemsDiscounted]: clientDiscountCount.toString(),
        [TABLES_HEADERS.percentItemsDiscounted]: `${parseFloat(clientDiscountPercent * 100).toFixed(1)}%`,
        [TABLES_HEADERS.givenDiscount]: currencySign({
          value: convertToMoneyAfterVat(service_discount_total + product_discount_total),
          currentSalonAbbr: this.props.currencySign,
        }),
        [TABLES_HEADERS.percentGivenDiscount]: `${parseFloat(stylistTotalDiscountPercent * 100).toFixed(1)}%`,
        [TABLES_HEADERS.serviceDiscount]: currencySign({
          value: convertToMoneyAfterVat(service_discount_total),
          currentSalonAbbr: this.props.currencySign,
        }),
        [TABLES_HEADERS.percentServiceDiscount]: `${parseFloat(serviceDiscountPercent * 100).toFixed(1)}%`,
        [TABLES_HEADERS.retailDiscount]: currencySign({
          value: convertToMoneyAfterVat(product_discount_total),
          currentSalonAbbr: this.props.currencySign,
        }),
        [TABLES_HEADERS.percentRetailDiscount]: `${parseFloat(retailDiscountPercent * 100).toFixed(1)}%`,
      };
    });

    const L = discountTable.length;
    const itemDiscountPercent = salonItemsChecked !== 0 ? salonTotalDiscountNumber / salonItemsChecked : 0;
    discountTable[L] = {
      [TABLES_HEADERS.staff]: 'Total',
      [TABLES_HEADERS.itemsCheckedOut]: salonItemsChecked,
      [TABLES_HEADERS.itemsDiscounted]: salonTotalDiscountNumber,
      [TABLES_HEADERS.percentItemsDiscounted]: `${parseFloat(itemDiscountPercent * 100).toFixed(2)}%`,
      [TABLES_HEADERS.givenDiscount]: currencySign({
        value: convertToMoneyAfterVat(salonTotalDiscount),
        currentSalonAbbr: this.props.currencySign,
      }),
      [TABLES_HEADERS.percentGivenDiscount]: '100%',
      [TABLES_HEADERS.serviceDiscount]: currencySign({
        value: convertToMoneyAfterVat(salonServiceDiscountTotal),
        currentSalonAbbr: this.props.currencySign,
      }),
      [TABLES_HEADERS.percentServiceDiscount]: '100%',
      [TABLES_HEADERS.retailDiscount]: currencySign({
        value: convertToMoneyAfterVat(salonProductDiscountTotal),
        currentSalonAbbr: this.props.currencySign,
      }),
      [TABLES_HEADERS.percentRetailDiscount]: '100%',
    };
    return discountTable;
  };

  makeCategoryDiscountTable = (data, discountReport) => {
    const categoryDiscountTable = [];
    const categoryDiscountObj = {};
    let salonTotalCategoryDiscount = 0;
    let salonClientsChecked = 0;
    let totalPercentDiscount = 0;

    const total = [];
    let categoryNames = [];
    const { category_group, total_checkedout_products, product_discounts_given, product_total_discount } =
      discountReport.lastRequestResponse;
    const categoryArr = Object.values(category_group);

    categoryArr.map((anCat) =>
      total.push([anCat.name, anCat.total_clients, anCat.category_discount_total, anCat.client_discount_count]),
    );

    for (let i = 0; i < total.length; i += 1) {
      categoryNames.push(total[i][0]);
    }
    categoryNames = new Set(categoryNames);
    categoryNames = Array.from(categoryNames);

    let totalDiscountNumber = 0;

    for (let j = 0; j < categoryNames.length; j += 1) {
      for (let i = 0; i < total.length; i += 1) {
        if (categoryNames[j] === total[i][0]) {
          categoryDiscountObj[categoryNames[j]] = {
            total_clients: total[i][1],
            category_discount_total: total[i][2],
            client_discount_count: total[i][3],
          };
          totalDiscountNumber += total[i][3];
        }
      }
      if (categoryDiscountObj[categoryNames[j]].category_discount_total) {
        salonTotalCategoryDiscount += categoryDiscountObj[categoryNames[j]].category_discount_total;
      }
    }
    salonTotalCategoryDiscount += product_total_discount;
    let salonItemsChecked = 0;
    categoryArr.map((ct) => {
      const l = categoryDiscountTable.length;
      const categoryDiscountPercent =
        salonTotalCategoryDiscount !== 0
          ? categoryDiscountObj[ct.name].category_discount_total / salonTotalCategoryDiscount
          : 0;
      salonClientsChecked += categoryDiscountObj[ct.name].total_clients;
      salonItemsChecked += categoryDiscountObj[ct.name].total_clients;
      // salonTotalCategoryDiscount += categoryDiscountObj[ct.name].discount;
      const clientDiscountPercent =
        categoryDiscountObj[ct.name].total_clients !== 0
          ? categoryDiscountObj[ct.name].client_discount_count / categoryDiscountObj[ct.name].total_clients
          : 0;
      totalPercentDiscount += categoryDiscountPercent;
      categoryDiscountTable[l] = {
        [TABLES_HEADERS.category]: ct.name,
        [TABLES_HEADERS.itemsCheckedOut]: categoryDiscountObj[ct.name].total_clients,
        [TABLES_HEADERS.itemsDiscounted]: categoryDiscountObj[ct.name].client_discount_count,
        [TABLES_HEADERS.percentItemsDiscounted]: `${parseFloat(clientDiscountPercent * 100).toFixed(1)}%`,
        [TABLES_HEADERS.givenDiscount]: currencySign({
          value: convertToMoneyAfterVat(categoryDiscountObj[ct.name].category_discount_total),
          currentSalonAbbr: this.props.currencySign,
        }),
        [TABLES_HEADERS.percentGivenDiscount]: `${parseFloat(categoryDiscountPercent * 100).toFixed(1)}%`,
      };
    });
    salonItemsChecked += total_checkedout_products;
    totalDiscountNumber += product_discounts_given;
    salonClientsChecked += total_checkedout_products;

    // add retail
    const retailDiscountPercent = total_checkedout_products ? product_discounts_given / total_checkedout_products : 0;
    const retailToTotalPercent =
      salonTotalCategoryDiscount !== 0 ? product_total_discount / salonTotalCategoryDiscount : 0;
    totalPercentDiscount += retailToTotalPercent;
    const retailObj = {
      [TABLES_HEADERS.category]: 'Retail',
      [TABLES_HEADERS.itemsCheckedOut]: total_checkedout_products,
      [TABLES_HEADERS.itemsDiscounted]: product_discounts_given,
      [TABLES_HEADERS.percentItemsDiscounted]: `${parseFloat(retailDiscountPercent * 100).toFixed(1)}%`,
      [TABLES_HEADERS.givenDiscount]: currencySign({
        value: convertToMoneyAfterVat(product_total_discount),
        currentSalonAbbr: this.props.currencySign,
      }),
      [TABLES_HEADERS.percentGivenDiscount]: `${parseFloat(retailToTotalPercent * 100).toFixed(1)}%`,
    };
    categoryDiscountTable.push(retailObj);
    // add total
    const L = categoryDiscountTable.length;
    const percenOfClientsGivenDiscount =
      salonClientsChecked !== 0
        ? `${parseFloat((totalDiscountNumber / salonClientsChecked) * 100).toFixed(2)}%`
        : '0.00%';

    const totalPercentDiscountGiven =
      totalPercentDiscount !== 0 ? `${parseFloat(totalPercentDiscount * 100).toFixed(2)}%` : '0.00%';
    categoryDiscountTable[L] = {
      [TABLES_HEADERS.category]: 'Total',
      [TABLES_HEADERS.itemsCheckedOut]: salonItemsChecked,
      [TABLES_HEADERS.itemsDiscounted]: totalDiscountNumber.toString(),
      [TABLES_HEADERS.percentItemsDiscounted]: percenOfClientsGivenDiscount,
      [TABLES_HEADERS.givenDiscount]: currencySign({
        value: convertToMoneyAfterVat(salonTotalCategoryDiscount),
        currentSalonAbbr: this.props.currencySign,
      }),
      [TABLES_HEADERS.percentGivenDiscount]: totalPercentDiscountGiven,
    };

    return categoryDiscountTable;
  };

  handleExportDiscountsTable = (options) => {
    const { data, keys, fileName } = options;

    const csvData = asArray(
      data.map((item) =>
        keys.reduce((acc, key) => {
          acc[key] = item[key];
          return acc;
        }, {}),
      ),
    );

    exportCSV({ data: csvData, fileName });
  };

  render() {
    const visits = {};
    let discountByStylistObj;
    let categoryDiscountObj;
    this.props.data.forEach((stylist) => {
      visits[stylist.name] = stylist.visits;
    });
    if (
      this.props.discountReport.lastRequestResponse &&
      this.props.discountReport.lastRequestResponse.stylist_group &&
      Object.keys(this.props.discountReport.lastRequestResponse.stylist_group).length > 0
    ) {
      discountByStylistObj = this.makeDiscountTable(this.props.data, this.props.discountReport);
      categoryDiscountObj = this.makeCategoryDiscountTable(this.props.data, this.props.discountReport);
    }

    const hasDiscountByStylist = fromAnyToBool(discountByStylistObj);

    return (
      <>
        <div id="itemised-discounts-by-staff">
          <div className="t-bgr cfix">
            <div className="t-wrap">
              <div className={CN.tableHeader}>
                <h2>Itemised Discounts by Staff member</h2>
                <Button
                  onClick={() =>
                    this.handleExportDiscountsTable({
                      data: discountByStylistObj,
                      keys: [
                        [TABLES_HEADERS.staff],
                        [TABLES_HEADERS.itemsCheckedOut],
                        [TABLES_HEADERS.itemsDiscounted],
                        [TABLES_HEADERS.percentItemsDiscounted],
                        [TABLES_HEADERS.givenDiscount],
                        [TABLES_HEADERS.percentGivenDiscount],
                      ],
                      fileName: 'Items Discounts by Staff member',
                    })
                  }
                  disabled={!hasDiscountByStylist}
                  variant="primaryForce"
                  width="small"
                  height="xs"
                >
                  <span className={CN.buttonFont}>{DOWNLOAD_EXCEL}</span>
                </Button>
              </div>
              <div className="t-discount cfix">
                <table className="discount-tbl 1" id="table-to-xls-1">
                  <tbody key="h1">
                    <tr>
                      <td colSpan="3">
                        <div className="date-in-tbl-for-export">
                          From <strong>{this.props.startDate}</strong> to <strong>{this.props.endDate}</strong>{' '}
                        </div>
                      </td>
                    </tr>
                    <tr className="t-h first-row">
                      <th className="a3 h" style={{ width: '168px' }}>
                        {TABLES_HEADERS.staff}
                      </th>
                      <th className="a3" style={{ width: '121px' }}>
                        <span className="bubble">
                          <span className="tooltip">
                            <div />
                          </span>
                        </span>
                        <span className="column-title">{TABLES_HEADERS.itemsCheckedOut}</span>
                      </th>
                      <th className="a3" style={{ width: '121px' }}>
                        <span className="bubble">
                          <span className="tooltip">
                            <div />
                          </span>
                        </span>
                        <span className="column-title">{TABLES_HEADERS.itemsDiscounted}</span>
                      </th>
                      <th className="a3" style={{ width: '121px' }}>
                        <span className="bubble">
                          <span className="tooltip">
                            <div />
                          </span>
                        </span>
                        <span className="column-title">{TABLES_HEADERS.percentItemsDiscounted}</span>
                      </th>
                      <th className="a3" style={{ width: '121px' }}>
                        <span className="bubble">
                          <span className="tooltip">
                            <div />
                          </span>
                        </span>
                        <span className="column-title">{TABLES_HEADERS.givenDiscount}</span>
                      </th>
                      <th className="a3" style={{ width: '121px' }}>
                        <span className="bubble">
                          <span className="tooltip">
                            <div />
                          </span>
                        </span>
                        <span className="column-title">{TABLES_HEADERS.percentGivenDiscount}</span>
                      </th>
                      <th style={{ width: 'auto' }} />
                    </tr>
                  </tbody>
                  {discountByStylistObj &&
                    discountByStylistObj.map((stylist, index) => (
                      <tr className="t-h" key={`${stylist.Staff.toString()}-0-${index}`}>
                        <td className="stylist-name">{stylist.Staff}</td>
                        <td className="t-value">{stylist[TABLES_HEADERS.itemsCheckedOut]}</td>
                        <td className="t-value">{stylist[TABLES_HEADERS.itemsDiscounted]}</td>
                        <td className="t-value">{stylist[TABLES_HEADERS.percentItemsDiscounted]}</td>
                        <td className="t-value">{stylist[TABLES_HEADERS.givenDiscount]}</td>
                        <td className="t-value">{stylist[TABLES_HEADERS.percentGivenDiscount]}</td>
                        <td />
                      </tr>
                    ))}
                </table>
              </div>
            </div>
          </div>
        </div>
        <div id="discounts-breakdown">
          <div className="t-bgr cfix">
            <div className="t-wrap">
              <div className={CN.tableHeader}>
                <h2>Discounts breakdown</h2>
                <Button
                  onClick={() =>
                    this.handleExportDiscountsTable({
                      data: discountByStylistObj,
                      keys: [
                        [TABLES_HEADERS.staff],
                        [TABLES_HEADERS.serviceDiscount],
                        [TABLES_HEADERS.percentServiceDiscount],
                        [TABLES_HEADERS.retailDiscount],
                        [TABLES_HEADERS.percentRetailDiscount],
                      ],
                      fileName: 'Discounts breakdown',
                    })
                  }
                  disabled={!hasDiscountByStylist}
                  variant="primaryForce"
                  width="small"
                  height="xs"
                >
                  <span className={CN.buttonFont}>{DOWNLOAD_EXCEL}</span>
                </Button>
              </div>
              <div className="t-breakdown cfix">
                <table className="breakdown-tbl" id="table-to-xls-2">
                  <tbody key="h2">
                    <tr>
                      <td colSpan="3">
                        <div className="date-in-tbl-for-export">
                          From <strong>{this.props.startDate}</strong> to <strong>{this.props.endDate}</strong>{' '}
                        </div>
                      </td>
                    </tr>
                    <tr className="t-h first-row">
                      <th className="a3 h" style={{ width: '168px' }}>
                        {TABLES_HEADERS.staff}
                      </th>
                      <th className="a3" style={{ width: '121px' }}>
                        <span className="bubble">
                          <span className="tooltip">
                            <div />
                          </span>
                        </span>
                        <span className="column-title">{TABLES_HEADERS.serviceDiscount}</span>
                      </th>
                      <th className="a3" style={{ width: '121px' }}>
                        <span className="bubble">
                          <span className="tooltip">
                            <div />
                          </span>
                        </span>
                        <span className="column-title">{TABLES_HEADERS.percentServiceDiscount}</span>
                      </th>
                      <th className="a3" style={{ width: '121px' }}>
                        <span className="bubble">
                          <span className="tooltip">
                            <div />
                          </span>
                        </span>
                        <span className="column-title">{TABLES_HEADERS.retailDiscount}</span>
                      </th>
                      <th className="a3" style={{ width: '121px' }}>
                        <span className="bubble">
                          <span className="tooltip">
                            <div />
                          </span>
                        </span>
                        <span className="column-title">{TABLES_HEADERS.percentRetailDiscount}</span>
                      </th>
                      <th style={{ width: 'auto' }} />
                    </tr>

                    {discountByStylistObj &&
                      discountByStylistObj.map((stylist, index) => (
                        <tr className="t-h" key={`${stylist.Staff.toString()}-${index}`}>
                          <td className="stylist-name">{stylist.Staff}</td>
                          <td className="t-value">{stylist[TABLES_HEADERS.serviceDiscount]}</td>
                          <td className="t-value">{stylist[TABLES_HEADERS.percentServiceDiscount]}</td>
                          <td className="t-value">{stylist[TABLES_HEADERS.retailDiscount]}</td>
                          <td className="t-value">{stylist[TABLES_HEADERS.percentRetailDiscount]}</td>
                          <td />
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {categoryDiscountObj && (
            <div className="t-bgr cfix">
              <div className="t-wrap">
                <div className={CN.tableHeader}>
                  <h2>Itemised Discounts by Category</h2>
                  <Button
                    onClick={() =>
                      exportCSV({
                        data: categoryDiscountObj,
                        fileName: 'Itemised Discounts by Category',
                      })
                    }
                    variant="primaryForce"
                    width="small"
                    height="xs"
                  >
                    <span className={CN.buttonFont}>{DOWNLOAD_EXCEL}</span>
                  </Button>
                </div>
                <div className="t-discount cfix">
                  <table className="discount-tbl" id="table-to-xls-3">
                    <tbody key="h3">
                      <tr className="t-h first-row">
                        <th className="a3 h" style={{ width: '168px' }}>
                          {TABLES_HEADERS.category}
                        </th>
                        <th className="a3" style={{ width: '121px' }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLES_HEADERS.itemsCheckedOut}</span>
                        </th>
                        <th className="a3" style={{ width: '121px' }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLES_HEADERS.itemsDiscounted}</span>
                        </th>
                        <th className="a3" style={{ width: '121px' }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLES_HEADERS.percentItemsDiscounted}</span>
                        </th>
                        <th className="a3" style={{ width: '121px' }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLES_HEADERS.givenDiscount}</span>
                        </th>
                        <th className="a3" style={{ width: '121px' }}>
                          <span className="bubble">
                            <span className="tooltip">
                              <div />
                            </span>
                          </span>
                          <span className="column-title">{TABLES_HEADERS.percentGivenDiscount}</span>
                        </th>
                        <th style={{ width: 'auto' }} />
                      </tr>
                    </tbody>
                    {categoryDiscountObj.map((category, index) => (
                      <tr className="t-h" key={`${category['Category'].toString()}-2-${index}`}>
                        <td className="stylist-name">{category.Category}</td>
                        <td className="t-value">{category[TABLES_HEADERS.itemsCheckedOut]}</td>
                        <td className="t-value">{category[TABLES_HEADERS.itemsDiscounted]}</td>
                        <td className="t-value">{category[TABLES_HEADERS.percentItemsDiscounted]}</td>
                        <td className="t-value">{category[TABLES_HEADERS.givenDiscount]}</td>
                        <td className="t-value">{category[TABLES_HEADERS.percentGivenDiscount]}</td>
                        <td />
                      </tr>
                    ))}
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
        <br /> <br /> <br />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  currencySign: selectCurrentSalonCurrency(state),
});

const DiscountByStylistHoc = connect(mapStateToProps)(DiscountByStylist);

export default DiscountByStylistHoc;
